const map: Record<string, string> = {
  helplineAddictionPrevention: 'file_priklausomybe',
  helplineDifficultChildhood: 'file_sunkiai_augantiems',
  helplineDomesticViolence: 'file_smurtas',
  helplineMenCrisis: 'file_vyrukrize',
  helplineMissingPerson: 'file_dinges_asmuo',
  helplinePregnancyCrisis: 'file_krizinis_nestumas',
  helplineSexualAbuse: 'file_prievarta',
  helplineSuicide: 'file_savizudybes',
  helplineViolenceAgainstChildren: 'file_smurtas_pries_vaikus',
};

export default function getHelplineFile(key: string): string {
  return map[key];
}
